(() => {
  const weekdays = 'Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday|Mon|Tue|Wed|Thu|Fri|Sat|Sun';
  const months = 'Jan(?:uary)?|Feb(?:ruary)?|Mar(?:ch)?|Apr(?:il)?|May|Jun(?:e)?|Jul(?:y)?|Aug(?:ust)?|Sep(?:tember)?|Oct(?:ober)?|Nov(?:ember)?|Dec(?:ember)?';
  const shipDateOnly = new RegExp(`^(?:Estimated|Est\\.?) Ship(?:ping)? Date: (?:(?:${weekdays}),? )?(?:${months})\\.? (?:0?[1-9]|[12]\\d|3[01])(?:,? \\d{4})?\\.?$`, 'i');

  function compactQuantity(quantity) {
    const picker = quantity.querySelector('.quantity-selector--product');
    const input = picker?.querySelector('[name="quantity"]');
    if (!input || quantity.querySelector('.pline-quantity-select')) return;
    const select = document.createElement('select');
    select.className = 'pline-quantity-select';
    select.setAttribute('aria-label', input.getAttribute('aria-label'));
    for (let value = 1; value < 10; value++) select.add(new Option(String(value), String(value)));
    select.add(new Option('10+', 'custom'));
    function sync() {
      const value = Number(input.value);
      const custom = !Number.isInteger(value) || value < 1 || value >= 10;
      select.value = custom ? 'custom' : String(value);
      select.hidden = custom;
      picker.hidden = !custom;
      picker.classList.toggle('pline-quantity-custom', custom);
    }
    select.addEventListener('change', () => {
      input.value = select.value === 'custom' ? '10' : select.value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      sync();
      if (select.hidden) input.focus();
    });
    input.addEventListener('change', sync);
    picker.before(select);
    sync();
  }

  function arrange(root) {
    root.querySelectorAll('.pline-editorial-purchase').forEach(purchase => {
      const payment = purchase.querySelector('.product-form__payment-container');
      const status = purchase.querySelector('.product-meta__status-row');
      if (!payment || !status) return;
      const section = purchase.closest('[data-section-type="product"]');
      let row = status.querySelector('.pline-availability-row');
      if (!row) {
        row = document.createElement('div');
        row.className = 'pline-availability-row';
        const stock = status.querySelector('.product-meta__stock-pill, .special-order-availability');
        status.prepend(row);
        if (stock) {
          row.appendChild(stock);
          if (stock.classList.contains('product-meta__stock-pill')) {
            for (const node of stock.childNodes) {
              if (node.nodeType === 3) {
                const label = node.textContent.trim().toLowerCase();
                node.textContent = label ? label[0].toUpperCase() + label.slice(1) : '';
              }
            }
          }
        }
      }
      let details = row.querySelector('.pline-availability-details');
      if (!details) {
        details = document.createElement('div');
        details.className = 'pline-availability-details';
        row.appendChild(details);
      }
      let date = purchase.querySelector('[data-estimated-ship-date]');
      const notes = section?.querySelector('.pline-editorial-notes');
      if (notes) {
        const legacyDates = Array.from(notes.querySelectorAll('.product-note')).filter(note =>
          shipDateOnly.test(note.textContent.trim().replace(/\s+/g, ' ')));
        if (date || section.dataset.hasShipDateField === 'true') {
          legacyDates.forEach(note => note.remove());
        } else if (legacyDates.length === 1) {
          date = legacyDates[0];
          date.classList.add('pline-estimated-ship-date');
          date.setAttribute('data-estimated-ship-date', '');
        }
      }
      if (date) details.prepend(date);
      row.classList.toggle('pline-availability-row--dated', Boolean(date));
      if (notes) notes.hidden = !notes.querySelector('.product-note');
      const notify = purchase.querySelector('.BIS_trigger');
      if (notify) {
        notify.type = 'button';
        notify.classList.remove('button', 'button--disabled', 'btn-darkgray', 'rounded--full');
        notify.classList.add('pline-notify-link');
        if (!notify.dataset.editorialLabel) {
          if (/^notify when available$/i.test(notify.textContent.trim())) {
            notify.textContent = purchase.dataset.notifyLabel;
            notify.dataset.editorialLabel = 'notification';
          } else {
            notify.dataset.editorialLabel = 'custom';
          }
        }
        details.appendChild(notify);
      }
      details.hidden = !details.children.length;
      const quantity = purchase.querySelector('.product-form__info-item--quantity');
      const add = payment.querySelector('[data-action="add-to-cart"]:not(:disabled)');
      if (quantity) {
        compactQuantity(quantity);
        quantity.hidden = !add;
        if (add) payment.insertBefore(quantity, add);
      }
      payment.classList.toggle('pline-purchase-grid', Boolean(quantity && add));
      payment.querySelectorAll('.pline-purchase-primary').forEach(button => button.classList.remove('pline-purchase-primary'));
      if (add && quantity) add.classList.add('pline-purchase-primary');
      let unavailable = payment.querySelector('.pline-unavailable-button');
      const needsUnavailable = !add && !payment.querySelector('.product-form__add-button') &&
        notify?.dataset.editorialLabel === 'notification' &&
        Boolean(row.querySelector('.product-meta__stock-pill--out_of_stock'));
      if (needsUnavailable && !unavailable) {
        unavailable = document.createElement('button');
        unavailable.type = 'button';
        unavailable.disabled = true;
        unavailable.className = 'pline-unavailable-button';
        unavailable.textContent = purchase.dataset.outOfStockLabel;
        payment.prepend(unavailable);
      }
      if (unavailable) unavailable.hidden = !needsUnavailable;
    });
  }
  arrange(document);
  document.addEventListener('DOMContentLoaded', () => arrange(document), { once: true });
  document.addEventListener('shopify:section:load', event => arrange(event.target));
  document.addEventListener('variant:changed', event => {
    const section = event.target.closest('[data-section-type="product"]');
    if (section) arrange(section);
  });
})();
